"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwTypeError = exports.tabs = void 0;
exports.tabs = ['overview', 'rules', 'prizes', 'surveys', 'faqs', 'register'];
const throwTypeError = (_) => {
    throw new Error('Missing case statement');
};
exports.throwTypeError = throwTypeError;
